import { useNavigate } from 'react-router-dom';
import { Bell, CheckCheck } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';
import { Card, EmptyState } from '../components/ui';
import { fmtDT } from '../utils/helpers';
import { classNames } from '../utils/helpers';

export default function Notifications() {
  const navigate = useNavigate();
  const { notifications, loading, unreadCount, markRead, markAllRead } = useNotifications();

  return (
    <div className="p-4 sm:p-6 space-y-4 max-w-3xl">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-navy">Notifications</h1>
        {unreadCount > 0 && (
          <button onClick={markAllRead} className="inline-flex items-center gap-1.5 text-sm text-brand hover:underline">
            <CheckCheck size={15} /> Mark all read
          </button>
        )}
      </div>

      <Card flush>
        {loading ? (
          <p className="p-6 text-sm text-gray-400">Loading…</p>
        ) : notifications.length === 0 ? (
          <EmptyState icon={Bell} title="No notifications" description="You're all caught up." />
        ) : (
          <ul className="divide-y divide-gray-100">
            {notifications.map(n => {
              const ticketId = (n as any).ticketId as string | undefined;
              return (
                <li key={n.id}>
                  <button
                    onClick={() => { if (!n.isRead) markRead(n.id); if (ticketId) navigate(`/tickets/${ticketId}`); }}
                    className={classNames('w-full text-left px-5 py-3.5 flex gap-3 hover:bg-gray-50', !n.isRead && 'bg-brand/[0.04]')}
                  >
                    <span className={classNames('mt-1.5 w-2 h-2 rounded-full shrink-0', n.isRead ? 'bg-transparent' : 'bg-brand')} />
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center justify-between gap-3">
                        <span className="text-sm font-medium text-navy truncate">{(n as any).subject ?? (n as any).notificationType ?? 'Notification'}</span>
                        <span className="text-xs text-gray-400 whitespace-nowrap">{fmtDT((n as any).sentAt)}</span>
                      </div>
                      {(n as any).body && <p className="text-xs text-gray-500 line-clamp-2 mt-0.5">{(n as any).body}</p>}
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </Card>
    </div>
  );
}
